import { ABILITY_TOKEN } from '@casl/vue';
export const TOKEN = ABILITY_TOKEN